import React, { useState } from "react";
import api from "../../lib/api";
import { Save } from "lucide-react";
import { toast } from "sonner";

const inp = "h-10 px-2 border border-stone-300 text-sm w-24 text-right";

export default function SetupTab({ blocks, onSaved }) {
  const [edits, setEdits] = useState({});
  const get = (b) => edits[b.id] || {
    vines_per_acre: b.vines_per_acre ?? "", emitter_gph: b.emitter_gph ?? "",
    emitters_per_vine: b.emitters_per_vine ?? "", hours_per_set: b.hours_per_set ?? "",
    kc: b.kc ?? "", deficit_pct: b.deficit_pct ?? "",
  };
  const set = (id, b, upd) => setEdits((s) => ({ ...s, [id]: { ...get(b), ...upd } }));

  const save = async (b) => {
    const e = get(b);
    const body = {};
    ["vines_per_acre", "emitter_gph", "emitters_per_vine", "hours_per_set", "kc", "deficit_pct"].forEach((k) => {
      if (e[k] !== "" && e[k] != null) body[k] = Number(e[k]);
    });
    try {
      await api.put(`/irrigation/setup/${b.id}`, body);
      toast.success(`${b.block || b.name} saved`);
      onSaved();
    } catch (err) { toast.error(err.response?.data?.detail || "Save failed"); }
  };

  const preview = (b) => {
    const e = get(b);
    const acres = Number(b.acres), vpa = Number(e.vines_per_acre), epv = Number(e.emitters_per_vine), gph = Number(e.emitter_gph);
    if (!acres || !vpa || !epv || !gph) return { vines: null, gph: null };
    const vines = Math.round(acres * vpa);
    return { vines, gph: Math.round(vines * epv * gph * 100) / 100 };
  };

  return (
    <div className="bg-white border border-stone-200 overflow-x-auto" data-testid="irr-setup-tab">
      <table className="w-full text-sm min-w-[900px]">
        <thead>
          <tr className="bg-[#1F3D34] text-white text-left text-[10px] uppercase">
            <th className="p-3">Block</th><th className="p-3 text-right">Acres</th>
            <th className="p-3 text-right">Vines / Acre</th><th className="p-3 text-right">Emitter GPH</th>
            <th className="p-3 text-right">Emitters / Vine</th><th className="p-3 text-right">Hours / Set</th>
            <th className="p-3 text-right">Kc</th><th className="p-3 text-right">Deficit %</th>
            <th className="p-3 text-right">Vines</th><th className="p-3 text-right">System Gal/hr</th><th className="p-3"></th>
          </tr>
        </thead>
        <tbody>
          {blocks.map((b) => {
            const e = get(b); const p = preview(b);
            return (
              <tr key={b.id} data-testid={`setup-row-${b.id}`} className="border-t border-stone-200">
                <td className="p-3 font-bold whitespace-nowrap">{b.block || b.name}
                  <div className="text-[10px] font-normal text-stone-500">{b.ranch_number} · {b.name}{b.variety ? ` · ${b.variety}` : ""}</div></td>
                <td className="p-3 text-right">{b.acres ?? "—"}</td>
                <td className="p-2 text-right"><input data-testid={`vpa-${b.id}`} type="number" value={e.vines_per_acre} onChange={(ev) => set(b.id, b, { vines_per_acre: ev.target.value })} className={inp} /></td>
                <td className="p-2 text-right"><input data-testid={`gph-${b.id}`} type="number" step="0.1" value={e.emitter_gph} onChange={(ev) => set(b.id, b, { emitter_gph: ev.target.value })} className={inp} /></td>
                <td className="p-2 text-right"><input data-testid={`epv-${b.id}`} type="number" step="1" value={e.emitters_per_vine} onChange={(ev) => set(b.id, b, { emitters_per_vine: ev.target.value })} className={inp} /></td>
                <td className="p-2 text-right"><input data-testid={`hps-${b.id}`} type="number" step="0.5" value={e.hours_per_set} onChange={(ev) => set(b.id, b, { hours_per_set: ev.target.value })} className={inp} /></td>
                <td className="p-2 text-right"><input data-testid={`kc-${b.id}`} type="number" step="0.05" value={e.kc} onChange={(ev) => set(b.id, b, { kc: ev.target.value })} className={inp} placeholder="0.7" /></td>
                <td className="p-2 text-right"><input data-testid={`deficit-${b.id}`} type="number" step="5" value={e.deficit_pct} onChange={(ev) => set(b.id, b, { deficit_pct: ev.target.value })} className={inp} placeholder="100" /></td>
                <td className="p-3 text-right text-stone-500">{p.vines ? p.vines.toLocaleString() : "—"}</td>
                <td className="p-3 text-right font-bold" data-testid={`sysgph-${b.id}`}>{p.gph ? p.gph.toLocaleString() : "—"}</td>
                <td className="p-2"><button data-testid={`save-setup-${b.id}`} onClick={() => save(b)} className="h-9 px-3 bg-[#1F3D34] text-white text-xs font-bold uppercase inline-flex items-center gap-1"><Save size={12} /> Save</button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
